import { identityBiometricService, identityBiometricCheckService } from '@afterpaytouch/portal-api/consumer/identityBiometric'
import { accountService } from '@afterpaytouch/portal-api/consumer/account'

export const { useCreateApplicantsMutation, useCreateInquiryIdMutation } = identityBiometricService

export const { useCheckBiometricStatusQuery } = identityBiometricCheckService

export const { useGetIdentitiesQuery } = accountService
